<template>
    <div class="d-flex justify-content-start mb-10">
        <!--begin::Wrapper-->
        <div class="d-flex flex-column align-items-start">
            <!--begin::User-->
            <div class="d-flex align-items-center mb-2">
                <div class="symbol symbol-35px symbol-circle">
                    <img alt="Pic" :src="image"/>
                </div>

                <!--begin::Details-->
                <div class="ms-3">
                    <a href="#" class="fs-5 fw-bolder text-gray-900 text-hover-primary me-1">{{ name }}</a>
                    <span class="text-muted fs-7 mb-1">{{ time }}</span>
                </div>
                <!--end::Details-->
            </div>
            <!--end::User-->

            <!--begin::Text-->
            <div class="p-5 rounded bg-light-info text-dark fw-bold mw-lg-400px text-start" data-kt-element="message-text">
                {{ text }}
                <div v-if="fileList.length">
                    <el-upload :file-list="fileList" class="upload-file show-upload-file" disabled :on-preview="previewFile"></el-upload>
                </div>
            </div>
            <!--end::Text-->
        </div>
    </div>
    <!--end::Wrapper-->
</template>

<script>
export default {
    name: "message-in",
    props: {
        name: { type: String },
        image: { type: String },
        time: { type: String },
        text: { type: String },
        attachments: { type: Array, default: () => { return [] }},
    },
    data(){
        return {
            fileList: []
        }
    },
    created(){
        if(this.attachments && this.attachments.length) {
            this.fileList = this.attachments.map((file) => {
                return {
                    name: file.name,
                    url: file.public_url
                }
            });
        }
    },
    methods: {
        previewFile(file){
            this.trustedWindowOpen(file.url, '_blank');
        },
    }
}
</script>
<style>
.upload-file .el-upload {
    width: 100%;
}

.upload-file .el-upload .el-upload-dragger{
    width: 100%;
}

.upload-file .svg-icon svg {
    height: 1em;
    width: 1em;
}

.show-upload-file .el-upload {
    display: none;
}
</style>